import { combineReducers } from 'redux';

import sharedData from './shared-data.reducer';
import exportedData from './exported-data.reducer';

export default combineReducers({
    sharedData,
    exportedData
});
